import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, Card, Form, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import 'react-widgets/dist/css/react-widgets.css';
import { dataPeriodsContructor } from 'src/utils/utils';
import AppLoading from 'src/components/common/AppLoading';

import PageTitle from 'src/components/general/PageTitle';
import { isNotEmptyArray } from 'src/services/validationService';

import {ROUTE_PATHS as ROUTES}  from 'src/routes';

import { getGlobalDataPeriodsData, getGlobalDataSelectedPeriod, getReportDatesData } from 'src/redux/globalData/globalDataReducer';
import { tryGetReportDeterminationPassiveResidues } from 'src/redux/reports/reportsActionCreactor';
import { getReportDeterminationPassiveResiduesIsFetching } from 'src/redux/reports/reportsReducer';
import { getListAllServiceAdministrativeByUserData, getListAllServiceAdministrativeByUserIsFetching } from 'src/redux/administrativeService/administrativeServiceReducer';
import { tryListAllServiceAdministrativeByUser } from 'src/redux/administrativeService/administrativeServiceActionCreator';
import { getEmail } from 'src/redux/login/loginReducer';
import { getUserListData } from 'src/redux/user/userReducer';
import { tryGetUserList } from 'src/redux/user/userActionCreator';
import { clearListAllServiceAdministrativeByUser } from 'src/redux/administrativeService/administrativeServiceActions';
import ExerciseServicesDateTo from 'src/components/pages/Reports/partials/ExerciseServicesDateTo';
import { shortlistedService } from 'src/utils/utils';

const ReportDeterminationPassiveResiduesPage = () => {
	const dispatch = useDispatch();
	const hookFormMethods = useForm();
	//User Id
	const email = useSelector( state => getEmail(state) );
	const listUserData = useSelector(state => getUserListData (state));
	const userId = listUserData?.records?.find(item => item.email == email);

	const reportDates = useSelector( state => getReportDatesData(state) );

	// Periods
	const periodList = useSelector( state => getGlobalDataPeriodsData(state) )?.data?.sort( (a,b) => a.year<b.year ? 1 : -1 );
	const hasPeriodList = isNotEmptyArray(periodList);
	const globalSelectedPeriod = useSelector( state => getGlobalDataSelectedPeriod(state) );

	//Services Administrative
	const administrativeService = useSelector(state => getListAllServiceAdministrativeByUserData(state))?.sort( (a,b) => a.code>b.code ? 1 : -1 );
	const administrativeServiceIsFetching = useSelector(state => getListAllServiceAdministrativeByUserIsFetching(state));

	const [dateTo, setDateTo] = useState(reportDates?.dateTo);

	const [dateHasErrors, setDateHasErrors] = useState(false);
	const [showMsgReportInProcess, setShowMsgReportInProcess] = useState(false);
	
	useEffect(() => {
		dispatch(clearListAllServiceAdministrativeByUser());
		dispatch(tryGetUserList());

		dispatch(tryListAllServiceAdministrativeByUser(userId?.id));

	}, []);

	//budget type
	const [budgetType, setBudgetType] = useState(null);

	const selectBudgetType = item => {
		setBudgetType(item);
	}

	const getReport = outputFormat => {
		if (globalSelectedPeriod) {
			setShowMsgReportInProcess(false);
			let params = {
				outputFormat,
				exerciseId: globalSelectedPeriod?.id,
				serviceIds: selected?.map(administrativeService => administrativeService?.value),
				dateTo,
				passiveRemaining: true,
				period_rp_id: budgetType,
			};

			if(params.period_rp_id === "RP"){
				const propToBeDeleted = 'period_rp_id';
				delete params[propToBeDeleted];
			}

			dispatch(tryGetReportDeterminationPassiveResidues(params)).then( response => {
				if(response?.status == 200 && outputFormat === 1){
					setShowMsgReportInProcess(true);
				}
			});
		}

	};

	const onClickPDF = () => getReport(1);

	const onClickXLS = () => getReport(2);

	//// Multiselect
	// View items selector
	const [options, setOptions] = useState([]);

	useEffect(() => {
		let optionsArray = [];
		let i = 0;
		for (i in administrativeService){
			optionsArray.push({label: administrativeService[i]?.code + " - " + administrativeService[i]?.shortName, value:  administrativeService[i]?.id} )
		}
		setOptions(optionsArray);
	}, [administrativeService]);

	useEffect(() => {
		const uniqueService = shortlistedService(options);
		if(uniqueService){
			setSelected(options);
		}
	}, [options]);

	// Add options
	const [selected, setSelected] = useState([]);
	
	const hasValueCustomValueRenderer = (selected.length === 0);		
	
	// Reports redux
	const reportIsFetching = useSelector(state => getReportDeterminationPassiveResiduesIsFetching(state));
	const allowGetReport = (hasPeriodList && !reportIsFetching && dateTo && !hasValueCustomValueRenderer && !dateHasErrors  && budgetType );

	//onChange events
	const onChangeBudgetType = (budgetTypeData) => {
		selectBudgetType(budgetTypeData);
	};

	return <Container fluid>
		<Card className='mb-5'>
			<PageTitle text='Reporte de Detalle de Residuos Pasivos' />

			<Container fluid>
				<Card className='mb-3'>
					<Card.Body>
						<Form>
							<Row>
								<Col sm={2}></Col>
								<Col sm={8}>

									<ExerciseServicesDateTo 
										globalSelectedPeriodYear={globalSelectedPeriod?.year}
										{...{dateTo, setDateTo, setDateHasErrors, selected, setSelected, options, administrativeServiceIsFetching, hookFormMethods}} />


									<Form.Group>
										<Form.Label className='text-black-color'>
											Tipo de partida presupuestaria
										</Form.Label>	
										<Form.Control
											as="select"
											name='tipoDeEjercicio'
											className="w-100 text-black-color"
											value={budgetType}
											onChange={(event) => onChangeBudgetType(event.target.value)}
										>
											<option	option className='text-black-color' value={''} disabled={true} selected >
												Seleccione una opción...
											</option>
											<option	option className='text-black-color' value={'RP'} >
												Residuo Pasivo
											</option>
											{
												<>
													{dataPeriodsContructor(globalSelectedPeriod, periodList).slice(1, 3).map((item, i) =>
														<option key={i} value={item?.period_rp_id}>
															{item?.value}
														</option>
													)}
												</>
											}
										</Form.Control>
									</Form.Group>

									{
										showMsgReportInProcess &&
										<Alert key={'1'} variant={'primary'} className='mt-4'>
											<b className='text-black-color' >Aviso:</b> El reporte se esta generando en segundo plano y estará disponible en el módulo de 
											<a  className='font-italic text-info cursor-pointer' 
												onClick={() => dispatch(push(ROUTES.REPORT_BUDGET_STATUS_CREDIT_EXECUTION_GENERATED))}>
												&nbsp;reportes generados.
											</a>
										</Alert>
									}

									<Form.Group className='d-flex justify-content-between mt-4'>
										<Button size='lg' onClick={onClickPDF} disabled={!allowGetReport}>
											<FontAwesomeIcon icon={faFilePdf} className='mr-2' />
											Generar PDF
										</Button>
										<div></div>
										{/* TODO: Se comenta el botón de descarga del reporte en formato Excel hasta que el BE sea desarrollado */}
										{/* <Button size='lg' onClick={onClickXLS} disabled={!allowGetReport}>
											<FontAwesomeIcon icon={faFileExcel} className='mr-2' />
											Generar XLS
										</Button> */}
										<AppLoading isLoading={reportIsFetching} />
									</Form.Group>
								</Col>
								<Col sm={3}></Col>
							</Row>

						</Form>
					</Card.Body>
				</Card>
			</Container>
		</Card>
	</Container>;
};

export default ReportDeterminationPassiveResiduesPage;

